import api from './apiClient'

export default {
    getTestInfo: async () => await api.get(`testHistory/test-info`),
    getTestHistory: async (testKey) => await api.get(`testHistory/${testKey}`),
    getTestResult: async (testKey) => await api.get(`testHistory/testResult/${testKey}`)
}